import React, {Component} from 'react';

/**
 * Component to display direct debit card
 */
class PaymentMethodDirectDebitCard extends Component {
    render() {
        const {
            description, cardHolderName, maskedRoutingNumber,
            maskedAccountNumber, fiName
        } = this.props;

        return (
            <div className="card-container echeck">
                <p className="pm-info echeck-type">{description}</p>
                <p className="pm-info account-holder-name">{cardHolderName}</p>
                <p className="pm-info bank-name">{fiName}</p>
                <p className="pm-info routing-number">{maskedRoutingNumber}</p>
                <p className="pm-info bank-account-number">{maskedAccountNumber}</p>
                <div className="echeck-decoration-overlay">
                    <div className="echeck-decoration-line1"/>
                    <div className="echeck-decoration-line2"/>
                    <div className="echeck-decoration-line3"/>
                    <div className="echeck-decoration-line4"/>
                    <div className="echeck-decoration-box1"/>
                    <div className="echeck-decoration-icon-lock">
                        <i className="fa fa-lock" aria-hidden="true"/>
                    </div>
                    <div className="echeck-decoration-icon-bank">
                        <i className="fa fa-university" aria-hidden="true"/>
                    </div>
                </div>
            </div>
        );
    }
}

export default PaymentMethodDirectDebitCard
